<script setup lang="ts">
  import { useTenantCreateOrEdit } from '@/models/tenant'
  import { useAuthStore } from '@/stores/auth'
  import TheNavbarBottom from './the-navbar-bottom.vue'
  import TheNavbarTop from './the-navbar-top.vue'

  const authStore = useAuthStore()
  const { submitting, errors, form, create } = useTenantCreateOrEdit()

  const submit = async () => {
    const response = await create()
    if (response) {
      authStore.reloadTenant()
    }
  }

  const version = __APP_VERSION__
</script>

<template>
  <div>
    <template v-if="authStore.authenticated === 1">
      <the-navbar-top />

      <div class="max-w-2xl pb-40 container">
        <div class="rounded-lg bg-white p-4 pt-20 -mx-4">
          <div
            v-if="authStore.tenants.length === 0"
            class="space-y-4">
            <div class="text-center">
              <fa-icon
                class="text-5xl text-primary"
                icon="i-far-sign-hanging" />
              <div class="font-medium">
                Masukkan nama usaha anda
              </div>
              <div class="text-xs">
                nama dapat diubah setelah mendaftar
              </div>
            </div>
            <form @submit.prevent="submit">
              <div class="space-y-4">
                <app-input
                  v-model="form.name"
                  :error="errors.name"
                  placeholder="Gradin" />
                <app-button
                  class="w-full btn-primary"
                  type="submit"
                  :loading="submitting">
                  Tambahkan
                </app-button>
              </div>
            </form>
          </div>
          <app-router-view v-else />
        </div>
        <aside class="mt-3 text-xs text-gray">
          <p>
            <app-button
              class="text-primary"
              :to="{name: 'log'}">
              v{{ version }}
            </app-button> - All right reserved by Gradin
          </p>
        </aside>
      </div>

      <the-navbar-bottom />
    </template>
  </div>
</template>
